import { getGlobalConfig } from '@core/globalConfig'
import { sanitizeWidgetParams } from '@core/params/helpers/sanitizeWidgetParams'
import { urlWidgetParams } from '@core/params/helpers/urlWidgetParams'
import type { IAnyWidgetParams } from '@core/types'
import { initialState } from '@core/widgets/store'
import { parseQueryParams } from '@core/window'

import type { BaseElement } from './BaseElement'
import type { Constructor } from './types'

/**
 * Mixin providing access to params (widget, global, ...).
 * @param superClass
 * @returns
 */
export const ParamsMixin = <T extends Constructor<BaseElement>>(
  superClass: T,
) => {
  class ParamsMixinClass extends superClass {
    /**
     * Get all custom element html attributes as a key value map.
     *
     * @returns The attributes key value map.
     */
    getAttributes(): Record<string, string> {
      const attributes = this.getAttributeNames()
      const result: Record<string, string> = {}
      for (const attribute of attributes) {
        const value = this.getAttribute(attribute)
        if (value !== null) {
          result[attribute] = value
        }
      }
      return result
    }

    /**
     * Merge default params, global params, custom element attributes and url params.
     */
    get params(): IAnyWidgetParams {
      return {
        ...initialState.defaultParams,
        ...sanitizeWidgetParams(getGlobalConfig()),
        ...sanitizeWidgetParams(this.getAttributes()),
        ...sanitizeWidgetParams(urlWidgetParams(parseQueryParams())),
      }
    }
  }

  return ParamsMixinClass
}
